import React from 'react'
import Post from './Post'
import * as API from './API'
import './cms.css'
import * as CacheUtil from '../util/CacheUtil'
import Loading from './Loading'

const TYPE = 'Post'
const POST__SLUG = 'Post__slug'

export default class PostPage extends React.Component {
  state={}
  componentDidMount() {
    this.setup()
  }
  setup=()=>{
    this.setState({loading:true},()=>{
      const slug = this.slug()
      if (typeof(slug)==='string'&&slug.length>0) {
        const slugs = CacheUtil.get(POST__SLUG)
        if (Array.isArray(slugs)&&slugs.length>0) {
          this.load(slugs)
        } else {
          this.fetchSlugs(TYPE)
        }
      }
    })
  }
  slug() {
    const {match} = this.props
    const {params} = match
    const {slug} = params
    if (typeof(slug)==='string'&&slug.length>0) {
      return slug
    }
    return ''
  }
  cbe=e=>{
    if (e) {
      this.setState((prevState,props)=>{
        const {err} = prevState
        const loading = false
        if (Array.isArray(err)) {
          err.push(e)
          return {err,loading}
        }
        return {err:[e],loading}
      })
    } else {
      this.setState({loading:false})
    }
  }
  fetchSlugs(type) {
    API.slugs(type,slugs=>{
      if (Array.isArray(slugs)) {
        CacheUtil.set(POST__SLUG,slugs)
        this.load(slugs)
      }
    })
  }
  load=slugs=>{
    if (Array.isArray(slugs)&&slugs.length>0) {
      const slug = this.slug()
      const index = slugs.findIndex(e=>e._slug===slug)
      if (index>=0) {
        const entry = slugs[index]
        const prev = slugs[index-1]
        const next = slugs[index+1]
        if (typeof(entry)==='object'&&entry!==null) {
          const {_id} = entry
          if (typeof(_id)==='string'&&_id.length>0) {
            this.fetchContent(TYPE,_id,content=>{
              if (typeof(content)==='object'&&content!==null) {
                this.setState({content,prev,next},()=>{
                  this.setState({loading:false})
                })
              }
            },this.cbe)
          }
        }
      }
    }
  }
  fetchContent(type,id,cb) {
    API.content(type,id,cb,this.cbe)
  }
  reload=()=>{
    this.setState((prevState,props)=>{
      delete prevState.content
      delete prevState.prev
      delete prevState.next
      return prevState
    }, this.setup)
  }
  render() {
    const {loading} = this.state
    const {content,prev,next} = this.state
    if (typeof(content)==='object'&&content!==null) {
      return (
        <Post {...this.props} content={content} prev={prev} next={next} onChange={this.reload} />
      )
    }
    if (loading) {
      return (
        <Loading {...this.props} onChange={this.reload} />
      )
    }
    return null
  }
}
